export default __webpack_public_path__ + "static/media/icon-burger.3609cd00.svg";